import { render, staticRenderFns } from "./nationalId.component.vue?vue&type=template&id=141e1cb6"
import script from "./nationalId.component.vue?vue&type=script&lang=ts"
export * from "./nationalId.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports